export default __webpack_public_path__ + "static/media/press_room_thumb1.58534652.png";